import type { ReceiptTemplate } from '../schema';

export const telegramTemplate: ReceiptTemplate = {
  id: 'telegram',
  name: 'Telegram Receipt',
  brand: 'TELEGRAM',
  description: 'Telegram Premium receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'tg-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: 'TELEGRAM',
        businessNameFontSize: 20,
        addressLines: ['PAYMENT RECEIPT'],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'tg-trans',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'invoice', label: 'Invoice:', value: 'TG-847291034' },
          { id: 'user', label: 'User:', value: '@johndoe' },
        ],
        column2: [
          { id: 'date', label: 'Date:', value: '01/04/2026' },
          { id: 'type', label: 'Type:', value: 'Annual' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'tg-plan',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'left', message: 'PLAN: Telegram Premium\nBILLING: Annual\nEXPIRES: 01/04/2027', fontSize: 12, showDivider: true, dividerStyle: 'dashed', isBold: false },
    },
    {
      id: 'tg-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'premium', label: 'PREMIUM (ANNUAL)', value: '35.88', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '2.96', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '38.84', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'tg-payment',
      type: 'payment',
      enabled: true,
      config: { alignment: 'left', method: 'VISA ****4144', fields: [], showDivider: true, dividerStyle: 'dashed' },
    },
    {
      id: 'tg-footer',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'center', message: 'PAYMENT SUCCESSFUL\n\nENJOY PREMIUM', fontSize: 12, showDivider: false, dividerStyle: 'solid', isBold: false },
    },
  ],
  updatedAt: new Date().toISOString(),
};

